import { combineReducers } from "redux";
import simpleReducer from "./simpleReducer";
import loginReducer from "./user_login_auth_reducer/user_login_auth_reducer";
import customerReducer from "./calender_reducer//calender_reducer";
import fillListReducer from "./fillReducer/fillList_reducer";
import bookingDetailsAsideReducer from "./bookingDetails_reducer/bookingDetailsAside_reducer/bookingDetailsAsideReducer";
import holidayReducer from "./master_reducer/holiday_reducer";
import eventReducer from "./master_reducer/events_reducer";
import bookingDetailsReducer from "./bookingDetails_reducer/bookingDetails_reducer";
import companyInfoReducer from "./bookingDetails_reducer/companyInfo_reducer";
import summaryReducer from "./bookingDetails_reducer/summary_reducer";
import orderConfirmationReducer from "./bookingDetails_reducer/orderConfirmation_reducer";
import cartReducer from "./bookingDetails_reducer/cart_reducer";
import termsAndConditonsReducer from "./bookingDetails_reducer/termsAndConditions_reducer";
import clientReducer from "./master_reducer/client_reducer";
import additionalServiceReducer from "./master_reducer/service_reducer";
import multiPurposeCentreReducer from "./master_reducer/multiPurposeCentre_reducer";
import myOrdersReducer from "./myOrders_reducer/myOrders_reducer";
import rolesReducer from "./security_reducer/roles_reducer";
import userReducer from './security_reducer/user_reducer';
import accountReceiptReducer from "./accounts_reducer/account_receipts_reducer";
import accountCreditNoteReducer from "./accounts_reducer/account_credit_note_reducer";
import accountDebitNoteReducer from "./accounts_reducer/account_debit_note_reducer";
import checkListReducer from "./checkList_reducer/checkList_reducer";
import feedbackReducer from "./feedback_reducer/feedback_reducer";
import accountThirdPartyOrderReducer from "./accounts_reducer/account_third_party_order_reducer";
import guidelineReducer from "./accounts_reducer/guideline_reducer";

export default combineReducers({
  simpleReducer,
  loginReducer,
  fillListReducer,
  customerReducer,
  holidayReducer,
  eventReducer,
  bookingDetailsReducer,
  companyInfoReducer,
  summaryReducer,
  termsAndConditonsReducer,
  additionalServiceReducer,
  orderConfirmationReducer,
  clientReducer,
  multiPurposeCentreReducer,
  userReducer,
  bookingDetailsAsideReducer,
  clientReducer,
  cartReducer,
  multiPurposeCentreReducer,
  myOrdersReducer,
  rolesReducer,
  clientReducer,
  multiPurposeCentreReducer,
  userReducer,
  accountReceiptReducer,
  accountCreditNoteReducer,
  accountDebitNoteReducer,
  checkListReducer,
  feedbackReducer,
  accountThirdPartyOrderReducer,
  guidelineReducer,
});
